<template>
  <v-container fluid class="card-planta mt-14" :key="componentKey">
    <v-row
      v-for="(itemPlanta, i) in plantWithDemands"
      :key="i + itemPlanta.cdPlantaAbate"
      class="ma-0 pa-0 card-item-planta mb-10 d-flex flex-column"
    >
      <v-row
        class="ma-0 flex-nowrap"
      >
        <v-col class="pa-0 ma-0 colunm-1-dados-lote" cols="2">
          <v-item-group class="pa-2">
            <v-item>
              <v-layout row justify-center ma-0>
                <v-flex lg11>
                  <span class="text-planta-abate">Planta de Abate</span>
                  <br />
                  <span
                    class="text-planta-abate-sif-not-filled"
                  >SIF {{ itemPlanta.plantaAbate.nrRegistroSif }}</span>
                  <br />
                  <span class="text-planta-abate-municipio">
                  {{
                      itemPlanta.plantaAbate.nmMunicipio
                  }}
                </span>
                  <br />
                  <div class="container-fluid">
                    <v-btn
                      v-if="!itemPlanta.showLotes"
                      class="btn-adicionar-lotes mt-2"
                      @click="changeShowLotes(itemPlanta)"
                    >Visualizar Lotes
                    </v-btn>
                    <v-btn
                      v-else
                      class="btn-adicionar-lotes mt-2"
                      @click="changeShowLotes(itemPlanta)"
                    >Esconder Lotes
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-item>
          </v-item-group>
        </v-col>
        <v-col
          v-for="(itemData, i) in listDatesWithDemand"
          :key="i + itemData.value"
          cols="2"
          class="pa-0 ma-0 colunm-2-dados-lote"
        >
          <v-item-group>
            <v-item>
              <v-layout row justify-center ma-0>
                <v-flex lg12>
                  <CardProgramacaoColumn
                    :itemData="itemData"
                    :itemPlanta="itemPlanta"
                    :showLotes="itemPlanta.showLotes"
                  />
                </v-flex>
              </v-layout>
            </v-item>
          </v-item-group>
        </v-col>
      </v-row>
      <v-row
        class="ma-0 flex-nowrap"
      >
        <v-col class="ma-0 pa-0 card-lotes-confirmados colunm-1-dados-demanda" cols="2">
          <v-item-group class="pl-3 pt-3">
            <v-item>
              <span class="text-demanda-plantas">Lotes Confirmados</span>
            </v-item>
          </v-item-group>
        </v-col>
        <v-col
          v-for="(itemData, i) in listDatesWithDemand"
          :key="i + itemData.value + 1"
          cols="2"
          class="ma-0 pa-0 card-lotes-confirmados colunm-2-dados-demanda"
        >
          <v-item-group class="fill-height">
            <v-item>
              <v-layout row justify-center class="fill-height" ma-0>
                <v-flex lg12>
                  <CardItemLotesConfirmados :itemData="itemData" :itemPlanta="itemPlanta" />
                </v-flex>
              </v-layout>
            </v-item>
          </v-item-group>
        </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>
'
<script>
import {mapActions, mapState} from "vuex"

import CardProgramacaoColumn from "@/modules/programacaoAbate/components/CardProgramacaoColumn"
import CardItemLotesConfirmados from "@/modules/programacaoAbate/components/CardItemLotesConfirmados"

export default {
  name: "ItemPlantaAbateProgramacaoProgramacao",
  components: {
    CardProgramacaoColumn,
    CardItemLotesConfirmados,
  },
  computed: {
    ...mapState("programacaoAbate", [
      "listDatesWithDemand",
      "listaDemandasPlanta",
    ]),
      plantWithDemands() {
      return this.listaDemandasPlanta.filter((item) => item.qtTotalDemanda)
        .sort((a, b) => a.plantaAbate.idPlantaAbate - b.plantaAbate.idPlantaAbate);
    }
  },
  data() {
    return {
      componentKey: 0,
    }
  },
  props: {},
  methods: {
    ...mapActions("programacaoAbate", ["ActionChangeShowLote"]),
    changeShowLotes(itemLote) {
      this.ActionChangeShowLote(itemLote)
      this.forceRerender()
    },
    forceRerender() {
      this.componentKey += 1
    },
  },
}
</script>

<style></style>
